<template>
<div id='page_Container'>
    <div class="page">
        <div id='main-container' class="main-container">
            <div class="container">
                <div class="grid-box Level-one-menu" v-if="categoryGrade === 1">
                    <grid-category :btnObj="btnObjOne" :cuIconList="tablist" @gridClick="gridMenuClick" @gridBtnClick="gridBtnClick"></grid-category>
                </div>
                <div class="platform-box Level-two-menu" v-if="categoryGrade === 2">
                    <div class="tabbar-left-box">
                        <div :class="['item', {active: index === currentIndex}]" v-for="(item, index) in tablist" :key="index" @click="changeTab(index,item)">
                            {{item.name}}
                        </div>
                    </div>
                    <div class="grid-box">
                        <grid-category ::btnObj="btnObjTwo" :cuIconList="categoryTwo" @gridClick="gridMenuClick" @gridBtnClick="gridBtnClick"></grid-category>
                    </div>
                </div>
                <div class="platform-box Level-three-menu" v-if="categoryGrade === 3">
                    <div class="tabbar-left-box">
                        <div :class="['item', {active: index === currentIndex}]" v-for="(item, index) in tablist" :key="index" @click="changeTab(index,item)">
                            {{item.name}}
                        </div>

                    </div>
                    <div class="grid-menu-box">
                        <div class="grid-box">
                            <button v-if="tablist[currentIndex].name" class="gridBtn" @click="gridOneBtnClick(tablist[currentIndex])">查看{{tablist[currentIndex].name}} ></button>
                            <div v-for="(item, index) in categoryTwo" :key="index">
                                <div class="menu-t-title">
                                    {{item.name}}
                                </div>
                                <grid-category :btnObj="'查看' + item.name" :cuIconList="item.productCategorySon" :gridCol="gridColTwo" :parentObj="item" @gridClick="gridMenuClick" @gridBtnClick="gridBtnClick(item)"></grid-category>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import gridCategory from '@/components/common/grid-category';
import {
    toastLoading,
    clearToastLoading,
    confirmModal
} from '@/utils/base/utils';
import {
    mapActions,
    mapGetters
} from 'vuex';
export default {
    components: {
        gridCategory
    },
    data() {
        return {
            categoryGrade: 0, // 几级菜单
            currentIndex: 0,
            tablist: [],
            categoryTwo: [], // 二级菜单
            categoryThree: [], // 三级菜单
            menuIndex: [],
            gridColOne: 3,
            gridColTwo: 3,
            gridColThree: 3,
            categoryTwoName: '', // 二级菜单名称
            btnObjOne: {
                id: 1,
                name: '查看全部'
            },
            btnObjTwo: {
                id: 1,
                name: '查看全部'
            },
            idOne: '', // 点击的一级id
            idTwo: '' // 点击的二级id
        };
    },
    esvShow() {
        this.getMerchantInfo();
        this.getIndexHeadMenu();
    },
    computed: {
        ...mapGetters(['searchInfo'])
    },
    methods: {
        ...mapActions(['setSearchInfo']),
        getMerchantInfo() {
            // 查询商户信息
            const self = this;
            this.$doRequest({
                url: '/merchant/getMerchantInfo',
                params: {

                },
                before() {
                    self.loading = toastLoading();
                },
                complete() {
                    clearToastLoading(self.loading);
                }
            }, function (data) {
                self.categoryGrade = data.result.categoryGrade;
                console.log(self.categoryGrade);
            });
        },
        getIndexHeadMenu() {
            const params = {};
            const self = this;
            this.$doRequest({
                url: '/index/getIndexHeadMenu',
                params: params,
                before() {
                    self.loading = toastLoading();
                },
                complete() {
                    clearToastLoading(self.loading);
                }
            }, (data) => {
                let tablist = [];
                if (this.categoryGrade !== 1) {
                    tablist = [{
                        id: '',
                        img: '',
                        name: '全部'
                    }];
                }
                this.menuIndex = data.result.menuIndex;
                this.menuIndex.forEach(item => {
                    tablist.push({
                        id: item.id,
                        img: item.img,
                        name: item.name
                    });
                });
                this.tablist = tablist;
                if (this.categoryGrade === 2) {
                    this.btnObjTwo = {
                        id: tablist[0].id,
                        name: '查看' + tablist[0].name
                    };
                }
                this.idOne = this.tablist[0].id;
                this.processData(this.menuIndex, 0);
            });
        },
        changeTab(index) {
            if (this.currentIndex === index) return;
            this.currentIndex = index;
            this.idOne = this.tablist[index].id;

            if (this.currentIndex === 0) {
                this.processData(this.menuIndex, index);
            } else {
                this.processData(this.menuIndex[this.currentIndex - 1], index);
            }
        },
        processData(menuIndex, index) {
            console.log(menuIndex);

            let categoryTwo = [];
            const categoryThree = [];
            if (this.currentIndex === 0) {
                menuIndex.forEach(menu => {
                    if (menu.productCategorySon.length > 0) {
                        if (this.categoryGrade === 1) {
                            menu.productCategorySon.forEach(son => {
                                categoryTwo.push({
                                    parentId: menu.id,
                                    id: son.id,
                                    img: son.img,
                                    name: son.name,
                                    productCategorySon: son.productCategorySon
                                });
                            });
                        } else if (this.categoryGrade === 2) {
                            categoryTwo = [];
                            this.tablist.forEach((item, i) => {
                                if (i !== 0) {
                                    categoryTwo.push({
                                        parentId: '',
                                        id: item.id,
                                        img: item.img,
                                        name: item.name,
                                        productCategorySon: []
                                    });
                                }
                            });
                        } else if (this.categoryGrade === 3) {
                            categoryTwo = [];
                            menuIndex.forEach((item, i) => {
                                categoryTwo.push({
                                    parentId: '',
                                    id: item.id,
                                    img: item.img,
                                    name: item.name,
                                    productCategorySon: item.productCategorySon
                                });
                            });
                        }

                        if (menu.productCategorySon[0].productCategorySon.length > 0) {
                            menu.productCategorySon[0].productCategorySon.forEach(grandson => {
                                categoryThree.push({
                                    id: grandson.id,
                                    img: grandson.img,
                                    name: grandson.name
                                });
                            });
                        }
                    }
                });
            } else {
                if (menuIndex.productCategorySon.length > 0) {
                    menuIndex.productCategorySon.forEach(son => {
                        categoryTwo.push({
                            id: son.id,
                            img: son.img,
                            name: son.name,
                            productCategorySon: son.productCategorySon
                        });
                    });
                    if (menuIndex.productCategorySon[0].productCategorySon.length > 0) {
                        menuIndex.productCategorySon[0].productCategorySon.forEach(grandson => {
                            categoryThree.push({
                                id: grandson.id,
                                img: grandson.img,
                                name: grandson.name
                            });
                        });
                    }
                }
            }
            this.categoryTwo = categoryTwo;
            if (this.categoryGrade === 2) {
                this.btnObjTwo = {
                    id: this.tablist[index].id,
                    name: '查看' + this.tablist[index].name
                };
            }
            if (this.categoryTwo[0] && this.categoryGrade === 3) {
                this.btnObjTwo = {
                    id: this.categoryTwo[0].id,
                    name: '查看' + this.categoryTwo[0].name
                };
                this.categoryTwoName = this.categoryTwo[0].name;
                this.idTwo = this.categoryTwo[0].id;
            }
            // this.gridColOne = this.setgridCol(this.tablist.length);
            // this.gridColTwo = this.setgridCol(this.categoryTwo.length);
            // this.gridColThree = this.setgridCol(this.categoryThree.length);
        },
        setgridCol(len) {
            let col;
            if (len === 1) {
                col = 1;
            } else if (len === 2) {
                col = 2;
            } else if (len >= 3) {
                col = 3;
            }
            return col;
        },
        // 三级菜单-一级菜单按钮点击
        gridOneBtnClick(item) {
            const categoryArr = `${item.id}`;
            this.jumpTo(categoryArr);
        },
        // 菜单点击
        gridMenuClick(item, index, parentObj) {
            let categoryArr;
            if (this.currentIndex === 0) {
                this.idOne = parentObj.parentId;
            }
            if (this.categoryGrade === 1) {
                categoryArr = item.id;
            } else if (this.categoryGrade === 2) {
                if (this.idOne) {
                    categoryArr = `${this.idOne},${item.id}`;
                } else {
                    categoryArr = item.id;
                }
            } else if (this.categoryGrade === 3) {
                this.categoryTwoName = item.name;
                this.btnObjTwo = {
                    id: item.id,
                    name: '查看' + item.name
                };
                if (this.idOne) {
                    categoryArr = `${this.idOne},${parentObj.id},${item.id}`;
                } else {
                    categoryArr = `${parentObj.id},${item.id}`;
                }
            }
            this.jumpTo(categoryArr);
        },
        // grid按钮点击
        gridBtnClick(item) {
            let categoryArr;
            console.log(item);
            if (this.currentIndex === 0 && item && item.parentId) {
                this.idOne = item.parentId;
            }
            if (this.categoryGrade === 1) {
                categoryArr = '';
            } else if (this.categoryGrade === 2) {
                categoryArr = `${this.idOne}`;
            } else if (this.categoryGrade === 3) {
                if (this.idOne) {
                    categoryArr = `${this.idOne},${item.id}`;
                } else {
                    categoryArr = item.id;
                }
            }
            this.jumpTo(categoryArr);
        },
        jumpTo(categoryArr) {
            // console.log(categoryArr);
            this.ESVStorage.putSavedValue('id', categoryArr);
            // this.setSearchInfo('');
            this.esvBackPage(1, true, () => {
                this.setSearchInfo({ ...this.searchInfo, searchFlag: '', styleType: '1' });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.platform-box {
    display: flex;

    .tabbar-left-box {
        background: #fff;
        position: fixed;
        top: 0;
        bottom: 0;
        width: 88px;
        overflow: auto;
        &::-webkit-scrollbar {display:none}

        .item {
            width: 100%;
            padding: 10px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999999;
            font-size: 14px;

            &.active {
                background: #F6F6F6;
                color: #ee2e50;
                position: relative;
            }

            &.active::before {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                border: 2px solid #ee2e50;
                height: 20px;
                top: 50%;
                transform: translate(0, -50%);
            }
        }
    }

    .grid-box {
        margin: 20px 10px 20px 98px;
        flex: 1;
    }
}

.Level-one-menu {
    margin: 20px 10px;
}

.Level-three-menu {
    .menu-t-title {
        margin: 20px 0 10px 0;
        font-size: 14px;
        color: #414141;
    }

    .gridBtn {
        background: #FFF6F8;
        color: #ee2e50;
        border: none;
        font-size: 14px;
        width: 100%;
        padding: 10px 0;
    }

    .gridBtn:after {
        border: none;
    }
}

.grid-menu-box {
    flex: 1;
}
</style>
